import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'benefits-bar',
    templateUrl: './benefits-bar.component.html',
    styleUrls: ['./benefits-bar.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class BenefitsBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
